<template>
	<div class="container">
		<transition mode="out-in" name="fade">
			<div class="transition-root" key="loadingCase" v-if="loading">
				<div class="row">
					<loading-indicator>{{$t('room.loading')}}..</loading-indicator>
				</div>
			</div>
			<div class="transition-root" key="startingCase" v-if="starting">
				<div class="row">
					<loading-indicator>{{$t('room.connecting')}}..</loading-indicator>
				</div>
			</div>
			<div class="transition-root" key="notLoading" v-if="!loading && !starting">
				<div class="mx-auto text-center">
					<h1 class="text-center">{{$t('room.roomCode')}}</h1>
					<p>Scan QR-koden, eller følg linket.<br>Indtast derefter nedenstående kode for at logge ind.</p>
					<emoji-code class="mb-3" type="large"/>
					<counter class="mb-5" :current="studentCount">
						{{$t('room.count')}}
					</counter>
					<app-button v-on:onClick="onClickStart" v-if="selectedType == 'dilemma'">
						{{$t('misc.start')}}
					</app-button>						
				</div>
				<div class="student-url-container">
					<h6 class="mb-1">Spiladresse</h6>
					<h6 class="student-url mb-0">
						{{ studentUrl }}
					</h6>
					<img :src="studentUrlQr" v-if="studentUrlQr" />
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	import GamePhase from '@/enum/GamePhase'
	import LoadingIndicator from '@/components/loading-indicator'
	import EmojiCode from '@/components/emoji-code'
	import Counter from '@/components/counter'
	import * as MutationTypes from '@/store/mutation-types'
	import AppButton from '@/components/app-button/index'
	import Media from '@/components/media'
	import {mapGetters} from 'vuex'
	import {getTeacherUrl} from '@/utils/UrlUtil'
	import QRCode from 'qrcode'
	import AppConfig from '@/app-config'

	export default {
		components: {
			AppButton,
			EmojiCode,
			LoadingIndicator,
			Counter,
			Media
		},
		data() {
			return {
				loading: true,
				starting: false,
				roomId: null,
				selectedType: '',
				case: null,
				pages: {
					dilemma: [],
					roleplay: []
				},
				studentUrlQr: null
			}
		},
		mounted() {
			if (!this.currentCase) {
				console.log('Current case missing');
				if (this.$gameClient) {
					this.closeRoom();
				}
				this.$router.push(getTeacherUrl('select-case'));
				return;
			}

			this.$gameClient.send({
				_phase: GamePhase.Lobby,
				_currentPageIndex: -1,
				_pageType: 'unset'
			})

			this.roomId = this.$gameClient.room.id
			let themeId = this.$store.getters.getCurrentTheme.id
			let caseId = this.currentCase.id

			this.$apiClient.getCase(caseId, (_case) => {
				this.case = _case;

				this.$apiClient.getCasePages(caseId, 'dilemma', (pages) => {
					this.pages.dilemma = pages;
					this.$apiClient.getCasePages(caseId, 'roleplay', (pages) => {
						this.pages.roleplay = pages;

						this.loading = false

						if (!AppConfig.roleplayEnabled) {
							// Roleplay isn't enabled, just automatically pick dilemma
							this.selectPageType('dilemma');
						}
					});
				});
			});

			this.$store.commit(MutationTypes.SET_BREADCRUMB_TO, () => {
				//When teacher leaves, all students are kicked by the server
				if (this.$gameClient) {
					this.closeRoom();
				}

				this.$router.push(getTeacherUrl('select-case'));
			});

			if (this.studentUrl) {
				this.generateStudentUrlQR();
			}
		},
		computed: {
			...mapGetters({
				currentCase: 'getCurrentCase',
			}),
			roleplayEnabled() {
				return AppConfig.roleplayEnabled;
			},
			caseTitle() {
				return this.currentCase ? this.currentCase.title : ''
			},
			caseDescription() {
				return this.currentCase ? this.currentCase.description : ''
			},
			studentCount() {
				return this.$gameClient.room.state.studentCount || 0
			},
			studentUrl() {
				return 'https://bit.ly/39cBAyo';
				//return 'https://onboarding.roskilde.seriousgames.net/#/student/connect';
			},
			selectedTypeString() {
				if (this.selectedType === 'dilemma') {
					return this.$t('room.dilemma');
				} else if (this.selectedType === 'roleplay') {
					return this.$t('room.roleplay');
				}

				return '';
			}
		},
		methods: {
			closeRoom() {
				//When teacher leaves, all students are kicked by the server
				this.$gameClient.leaveRoom();
				this.$store.dispatch({type: 'fullReset'});
			},
			onClickStart() {
				if (this.starting) {
					return
				}

				this.starting = true

				console.log('Changing game phase to GamePhase.Pages')

				this.$gameClient.send({
					_phase: GamePhase.Pages,
					_currentPageIndex: 0
				})
			},
			selectPageType(type) {
				if (this.selectedType == 'roleplay' && type == 'dilemma' && this.studentCount > 0) {
					if (!confirm(this.$t('room.typeChangeWarning'))) {
						return;
					}
				}

				this.selectedType = type;
				this.case.pages = this.pages[type];
				this.$store.commit(MutationTypes.SET_CURRENT_CASE, this.case);
				this.$gameClient.send({
					_pageType: type
				});

        		this.infoPage = 1;
			},
			onInfoPageStart() {
				this.infoPage = null;
				this.showRoomCode = true
			},
			generateStudentUrlQR() {
				QRCode.toDataURL(this.studentUrl)
					.then(url => {
						this.studentUrlQr = url;
					})
					.catch(err => {
						console.error('Could not generate QR code: ' + err)
					});
			}
		},
		watch: {
			studentUrlQr() {
				this.generateStudentUrlQR();
			}
		}
	}
</script>

<style lang="less" scoped>
	@import "~@less/variables.less";
	@import "~@less/font-sizes.less";

	.student-url-container {
		position: fixed;
		bottom: 50px;
		left: 50px;
	}

	.student-url {
		color: @roskilde-blue;
	}
</style>
